import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useAnalytics = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const isPaid = searchParams.get('paid');
    if (isPaid) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-16691672461/c3cgCLjz3LUaEI3rmpc-',
        'value': 12.99,
        'currency': 'USD',
        'transaction_id': ''
      });
    }
  }, []);
};
